import moment from 'moment'

import { CHILD_CODE, INFANT_CODE } from '@/components/booking/types'

export default class BookingParticipantsService {
  constructor (offer, existingParticipants) {
    this.offer = offer
    this.existingParticipants = existingParticipants
    
    // Check if we have the offer data
    if (existingParticipants && offer && offer.Persons) {
      const adultCount = offer.Persons.filter(p => p.Gender !== CHILD_CODE && p.Gender !== INFANT_CODE).length
      const childCount = offer.Persons.filter(p => p.Gender === CHILD_CODE || p.Gender === INFANT_CODE).length
      
      // Clear storage if either adult or child count doesn't match
      const storedAdults = existingParticipants.filter(p => p.type === 'adult').length
      const storedChildren = existingParticipants.filter(p => p.type === 'child' || p.type === 'infant').length

      if (storedAdults !== adultCount || storedChildren !== childCount) {
        localStorage.removeItem('bookingForm')
        this.existingParticipants = null
      }
    }
  }

  setChild (person) {
    return {
      id: person.Id,
      type: 'child',
      title: 'Dziecko',
      firstName: '',
      lastName: '',
      gender: '',
      birthday: moment(person.Birthdate),
      price: person.Price || 0,
    }
  }

  setInfant (person) {
    return {
      id: person.Id,
      type: 'infant',
      title: 'Niemowlę',
      firstName: '',
      lastName: '',
      gender: '',
      birthday: moment(person.Birthdate),
      price: person.Price || 0,
    }
  }

  setAdult (person) {
    return {
      id: person.Id,
      type: 'adult',
      title: 'Osoba dorosła',
      firstName: '',
      lastName: '',
      gender: '',
      birthday: moment(0),
      price: person.Price || 0,
    }
  }

  get data () {
    if (this.existingParticipants && this.existingParticipants.length) {
      return this.existingParticipants.map(p => {
        const offerPerson = this.offer.Persons.find(op => op.Id === p.id)
        
        const mappedParticipant = {
          id: p.id,
          type: p.type || 'adult',
          firstName: p.firstName || '',
          lastName: p.lastName || '',
          gender: p.gender || '',
          birthday: p.birthday ? moment(p.birthday) : moment(0),
          title: p.title || 'Osoba dorosła',
          price: offerPerson ? offerPerson.Price : 0,
        }
        return mappedParticipant
      })
    }

    return this.offer.Persons.map(person => {
      if (person.Gender === CHILD_CODE) return this.setChild(person)
      if (person.Gender === INFANT_CODE) return this.setInfant(person)
      return this.setAdult(person)
    })
  }
}


// WEBPACK FOOTER //
// ./src/services/BookingParticipantsService.js